import { render, staticRenderFns } from "./color-input.vue?vue&type=template&id=266efe8c&"
import script from "./color-input.vue?vue&type=script&lang=js&"
export * from "./color-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports